import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import './Landing.css';

const ETAPAS = [
  { n: '1', titulo: 'Preencha os dados', texto: 'Registre os dados do fotografado e o tipo de uso da imagem em poucos passos. O termo de autorização é montado para você.' },
  { n: '2', titulo: 'Colha a assinatura', texto: 'A pessoa assina na tela do celular o termo de autorização de uso de imagem, no estúdio ou em campo.' },
  { n: '3', titulo: 'Envie o PDF', texto: 'Tudo fica registrado. O documento em PDF, assinado, é enviado por e-mail para você e para o fotografado.' },
  { n: '4', titulo: 'Menos papel (ESG)', texto: 'Redução do consumo de papel: substitua o formulário impresso por um fluxo digital.' },
];

const PERGUNTAS = [
  {
    p: 'O que é o Autoriza Foto?',
    r: 'É um aplicativo para fotógrafos colherem o termo de autorização de uso de imagem com assinatura digital no celular: você preenche os dados, a pessoa assina na tela e o PDF é enviado por e-mail.',
  },
  {
    p: 'Como fazer uma autorização de uso de imagem?',
    r: 'No aplicativo, você informa os dados de quem foi fotografado e o tipo de uso da imagem, registra a foto, colhe a assinatura na tela do celular e envia o PDF por e-mail. O termo é montado para você, sem formulário em papel.',
  },
  {
    p: 'Preciso instalar alguma coisa?',
    r: 'Não é obrigatório: funciona direto no navegador do celular. Se preferir, dá para instalar na tela inicial, como um aplicativo (veja a dica em "Instalar o app no celular").',
  },
  {
    p: 'Como a pessoa assina?',
    r: 'Com o dedo, na tela do celular, ao final do preenchimento. A assinatura e a foto são incluídas no PDF gerado.',
  },
  {
    p: 'Para quem vai o PDF?',
    r: 'Para o fotógrafo e para a pessoa fotografada, por e-mail, logo depois da assinatura.',
  },
  {
    p: 'Posso testar antes de assinar?',
    r: 'Sim. Ao criar a conta, você tem 7 dias grátis, sem custo.',
  },
  {
    p: 'O app substitui a orientação de um advogado?',
    r: 'Não. O Autoriza Foto organiza e registra as autorizações de forma digital, mas não substitui a orientação jurídica para o seu caso concreto.',
  },
  {
    p: 'E os dados das pessoas fotografadas?',
    r: (
      <>
        Os dados são tratados conforme descrito na{' '}
        <Link to="/privacidade">Política de Privacidade</Link>.
      </>
    ),
  },
];

function Landing() {
  const navigate = useNavigate();
  const [erroLink, setErroLink] = useState(null);
  const [confirmadoComSucesso, setConfirmadoComSucesso] = useState(false);
  const [emailReenvio, setEmailReenvio] = useState('');
  const [reenviando, setReenviando] = useState(false);
  const [reenviado, setReenviado] = useState(false);

  useEffect(() => {
    // O Supabase redireciona para cá (Site URL) depois de processar o link
    // de um e-mail (confirmação de cadastro, redefinição de senha) — tanto
    // em caso de sucesso quanto de erro. Sem tratar isso, o usuário caía
    // numa Landing page genérica sem entender o que tinha acontecido.
    if (window.location.hash.includes('error=')) {
      const params = new URLSearchParams(window.location.hash.slice(1));
      const codigo = params.get('error_code');
      if (codigo === 'otp_expired') {
        setErroLink('Este link expirou ou já foi usado. Isso costuma acontecer quando o e-mail é aberto muito tempo depois de enviado, ou quando um e-mail mais antigo é usado por engano — solicite um novo abaixo.');
      } else {
        setErroLink('Não foi possível concluir essa ação pelo link. Solicite um novo e-mail de confirmação abaixo.');
      }
      window.history.replaceState(null, '', window.location.pathname);
    } else if (window.location.hash.includes('type=signup')) {
      setConfirmadoComSucesso(true);
      window.history.replaceState(null, '', window.location.pathname);
    }
  }, []);

  const handleReenviar = async () => {
    if (!emailReenvio) return;
    setReenviando(true);
    await supabase.auth.resend({ type: 'signup', email: emailReenvio });
    setReenviando(false);
    setReenviado(true);
  };

  // Já está rodando como app instalado (PWA ou app da Google Play)? Então o
  // aviso de instalação não faz sentido e fica escondido.
  const jaInstalado = (() => {
    try {
      return (
        window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone === true ||
        (document.referrer || '').startsWith('android-app://')
      );
    } catch (e) {
      return false;
    }
  })();

  return (
    <div className="lp">

      {/* Cabeçalho */}
      <header className="lp-header">
        <a className="lp-marca" href="#inicio" aria-label="Autoriza Foto — início">
          <span className="lp-marca-icone" aria-hidden="true">&#128248;</span>
          <span className="lp-marca-nome">
            Autoriza Foto
            <small>Autorização de Uso de Imagem</small>
          </span>
        </a>
        <nav className="lp-nav" aria-label="Seções da página">
          <a href="#inicio">Início</a>
          <a href="#como-funciona">Como funciona</a>
          <a href="#perguntas-frequentes">Perguntas frequentes</a>
          <a href="#contato">Contato</a>
        </nav>
        <Link to="/login" className="lp-entrar">Entrar</Link>
      </header>

      {confirmadoComSucesso && (
        <div className="lp-aviso">
          <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '10px', padding: '16px', fontFamily: 'system-ui', textAlign: 'center' }}>
            <p style={{ color: '#16a34a', fontSize: '14px', margin: '0 0 12px', fontWeight: '600' }}>✓ E-mail confirmado com sucesso!</p>
            <button
              onClick={() => navigate('/login')}
              style={{ width: '100%', background: '#d4a853', color: '#0d3d4a', border: 'none', borderRadius: '8px', padding: '12px', fontSize: '14px', fontWeight: '700', cursor: 'pointer' }}
            >
              Fazer login →
            </button>
          </div>
        </div>
      )}

      {erroLink && (
        <div className="lp-aviso">
          <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '10px', padding: '16px', fontFamily: 'system-ui' }}>
            <p style={{ color: '#dc2626', fontSize: '13px', margin: '0 0 12px', lineHeight: '1.5' }}>⚠️ {erroLink}</p>
            {!reenviado ? (
              <>
                <input
                  type="email"
                  placeholder="Seu e-mail"
                  aria-label="Seu e-mail"
                  value={emailReenvio}
                  onChange={(e) => setEmailReenvio(e.target.value)}
                  style={{ width: '100%', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '8px 12px', fontSize: '13px', marginBottom: '8px', boxSizing: 'border-box' }}
                />
                <button
                  onClick={handleReenviar}
                  disabled={!emailReenvio || reenviando}
                  style={{ width: '100%', background: '#d4a853', color: '#0d3d4a', border: 'none', borderRadius: '8px', padding: '10px', fontSize: '13px', fontWeight: '700', cursor: emailReenvio ? 'pointer' : 'not-allowed', opacity: emailReenvio ? 1 : 0.5 }}
                >
                  {reenviando ? 'Enviando...' : 'Reenviar e-mail de confirmação'}
                </button>
              </>
            ) : (
              <p style={{ color: '#16a34a', fontSize: '13px', margin: 0 }}>✓ Novo e-mail enviado! Verifique sua caixa de entrada (e o spam).</p>
            )}
          </div>
        </div>
      )}

      <main>
        {/* Hero */}
        <section id="inicio" className="lp-hero" aria-labelledby="titulo-principal">
          <div>
            <p className="lp-eyebrow">Aplicativo para fotógrafos</p>
            <h1 id="titulo-principal">
              <span className="lp-h1-a">Autorização</span>
              <span className="lp-h1-b">de Uso de Imagem</span>
            </h1>
            <div className="lp-regua"></div>
            <p className="lp-sub">
              Validade jurídica na palma da mão. Para fotógrafos que respeitam a lei e seus fotografados.
            </p>
            <p className="lp-sub lp-sub2">
              Colha a assinatura digital no celular e envie o termo de autorização de imagem em PDF.
            </p>

            <div className="lp-ctas">
              <Link to="/login" className="lp-btn lp-btn-principal">Acessar o app</Link>

              <div className="lp-ou">
                <i></i><span>Primeira vez aqui?</span><i></i>
              </div>

              <Link to="/registro" className="lp-btn lp-btn-secundario">Criar conta</Link>
              <p className="lp-teste">🛡️ 7 dias grátis, sem custo. Comece a proteger seu trabalho.</p>
              <Link
                to="/registro"
                className="lp-btn lp-btn-assinar"
                onClick={() => {
                  // Diferente de "Criar conta": aqui a pessoa já decidiu pagar
                  // direto, sem passar pelos 7 dias de teste grátis. O flag é
                  // lido em Cadastro.js logo após o login, mandando direto
                  // para /planos em vez de liberar o trial.
                  sessionStorage.setItem('pularTrial', '1');
                }}
              >
                Assinar
              </Link>
            </div>

            {/* Como instalar no celular */}
            {!jaInstalado && (
              <div className="lp-instalar">
                <details>
                  <summary>📲 Instalar o app no celular</summary>
                  <div>
                    <p><strong>Android (Chrome):</strong> toque no menu (⋮) e em <em>Instalar app</em> ou <em>Adicionar à tela inicial</em>.</p>
                    <p><strong>iPhone (Safari):</strong> toque em <em>Compartilhar</em> e em <em>Adicionar à Tela de Início</em>.</p>
                  </div>
                </details>
              </div>
            )}
          </div>

          <div className="lp-foto">
            <img
              src="/images/estudio-autorizacao.webp"
              width="768"
              height="512"
              alt="Fotógrafo fotografando uma modelo em estúdio; ao lado, um termo de Autorização de Uso de Imagem assinado e o passo a passo: a pessoa é fotografada, assina a autorização e tudo fica digital"
              fetchpriority="high"
              decoding="async"
            />
          </div>
        </section>

        {/* Como funciona + Benefícios */}
        <div className="lp-faixa">
          <section id="como-funciona" className="lp-secao" aria-labelledby="titulo-como-funciona">
            <h2 id="titulo-como-funciona">Como funciona</h2>
            <p className="lp-intro">
              O Autoriza Foto é um aplicativo para fotógrafos que precisam registrar, de forma simples e organizada, a autorização de uso de imagem de quem aparece em suas fotos.
            </p>
            <ol className="lp-cards">
              {ETAPAS.map((e) => (
                <li key={e.titulo} className="lp-card">
                  <span className="lp-etapa-n" aria-hidden="true">{e.n}</span>
                  <h3>{e.titulo}</h3>
                  <p>{e.texto}</p>
                </li>
              ))}
            </ol>
          </section>
        </div>

        {/* Perguntas frequentes */}
        <section id="perguntas-frequentes" className="lp-secao" aria-labelledby="titulo-faq">
          <h2 id="titulo-faq">Perguntas frequentes</h2>
          <div className="lp-faq">
            {PERGUNTAS.map((q) => (
              <details key={q.p}>
                <summary>{q.p}</summary>
                <p>{q.r}</p>
              </details>
            ))}
          </div>
        </section>

        {/* Contato */}
        <section id="contato" className="lp-secao lp-contato" aria-labelledby="titulo-contato">
          <h2 id="titulo-contato">Contato</h2>
          <p>
            Dúvidas ou sugestões? Escreva para{' '}
            <a href="mailto:autorizafoto@gmail.com">autorizafoto@gmail.com</a>.
          </p>
        </section>
      </main>

      {/* Rodapé */}
      <footer className="lp-rodape">
        <p>
          autorizafoto.com.br &nbsp;·&nbsp; Art. 20 CC &nbsp;·&nbsp; LGPD
        </p>
        <p>
          <Link to="/privacidade">Política de Privacidade</Link>
          &nbsp;·&nbsp;
          <Link to="/termos">Termos de Uso</Link>
          &nbsp;·&nbsp;
          <Link to="/excluir-conta">Excluir conta</Link>
        </p>
      </footer>

    </div>
  );
}

export default Landing;
